import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function signixEmailLimitValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value.length <= 50 ? null : { signixEmailTooLong: true };
  };
}
